import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import {Chart} from 'chart.js';

@Component({
  selector: 'sm-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss']
})
export class LineChartComponent implements OnInit {
  public chart: any;
  canvas: any;
  ctx: any;
  @Input() dataSource: any = {}
  // @ViewChild('mychart') mychart:any;
  @ViewChild('mychart', {static: false}) mychart!: ElementRef;
  constructor() { }

  ngOnInit(): void {
    // this.createChart();
  }


ngAfterViewInit() {
  if(this.dataSource.labels.length == 0){

  }
setTimeout(() => {
  console.log(this.dataSource);
  
  this.canvas = this.mychart.nativeElement;

this.ctx = this.canvas.getContext('2d');

new Chart(this.ctx, {
    type: 'line',
    data: this.dataSource,
    options: {
      legend: {
        display: true,
        position: 'bottom'
    },
      // scales: {
      //     yAxes: [{
      //         ticks: {
      //             beginAtZero: true
      //         }
      //     }]
      // }
  }

});
}, 100);

}

  // createChart(){
  
  //   this.chart = new Chart("MyChart", {
  //     type: 'line', //this denotes tha type of chart

  //     data: {// values on X-Axis
  //       labels: ['2022-05-10', '2022-05-11', '2022-05-12','2022-05-13',
	// 							 '2022-05-14', '2022-05-15', '2022-05-16','2022-05-17', ], 
	//        datasets: [
  //         {
  //           label: "Sales",
  //           data: ['467','576', '572', '79', '92',
	// 							 '574', '573', '576'],
  //           backgroundColor: 'blue'
  //         },
  //         {
  //           label: "Profit",
  //           data: ['542', '542', '536', '327', '17',
	// 								 '0.00', '538', '541'],
  //           backgroundColor: 'limegreen'
  //         }  
  //       ]
  //     },
  //     options: {
  //       aspectRatio:2.5
  //     }
      
  //   });
  // }

}
